import { QueryWrapper } from '@diamond/shared/data-access';
import { ValuationTypeItem } from '@diamond/shared/types';
import { useAuthStore } from '@diamond/sol-admin/features/auth';

type queryString = {
  size: number;
  page: number;
};

type Options = {
  enabled?: boolean;
};

export const useValuationType = (
  productId: string,
  queryString: queryString,
  options?: Options
) => {
  const session = useAuthStore();

  const queryCancelReason = QueryWrapper(
    `/backoffice/product/${productId}/valuation-type`,
    session.access_token
  );

  const { data: valuationTypeData } =
    queryCancelReason.useQueryGetAll<ValuationTypeItem>(
      `ValuationType${productId}`,
      queryString,
      undefined,
      undefined,
      {
        enabled: options?.enabled ?? true,
      }
    );

  return {
    valuationTypeData,
  };
};
